import { forwardRef } from 'react';
import { Link, useLocation, LinkProps } from 'react-router';

type WaitlistLinkProps = Omit<LinkProps, 'to'>;

const WaitlistLink = forwardRef<HTMLAnchorElement, WaitlistLinkProps>((props, ref) => {
  const location = useLocation();
  const waitlistPath = `waitlist${location.search}`;

  // eslint-disable-next-line flexcar/use-reload-document
  return <Link to={waitlistPath} ref={ref} {...props} />;
});

WaitlistLink.displayName = 'WaitlistLink';

export default WaitlistLink;
